import StatsPanel from "../components/StatsPanel";
import { trpc } from "../../main/components/trpc.ts";
import { Link } from "wouter";

const StatsContainer = () => {
  const { data: statsObject } = trpc.stats.get.useQuery();
  const { data: futureDoctolibSlots } =
    trpc.stats.getFutureDoctolibAvailableSlots.useQuery();

  const extendedStats = statsObject
    ? {
        ...statsObject,
        futureDoctolibAvailableSlots: futureDoctolibSlots ?? 0,
      }
    : null;

  return (
    <>
      <Link href="/quotes" className="m-4 inline-block text-blue-700 underline">
        Suivi et taux d’acceptation des devis
      </Link>
      <StatsPanel statsObject={extendedStats} />
    </>
  );
};

export default StatsContainer;
